import { txLabel } from '../utils/taxonomyLabel';  // CON-1606 — DB taxonomy via i18n
// ============================================
// COMPLETE EVENT TYPE HIERARCHY SCHEMA
// Auto-generated from HL_EventTypes_L1L2_slugs_filled.csv
// 342 event types mapped with display names, icons, and parent categories
// ============================================

// ETC1 (Level 1 - Top Categories) Display Names & Config
export const ETC1_CONFIG = {
  'ETC1_outdoor_adventure': { label: 'Outdoor & Adventure', icon: '🏔️', color: '#22c55e' },
  'ETC1_nightlife_entertainment': { label: 'Nightlife', icon: '🎵', color: '#8b5cf6' },
  'ETC1_food_drink': { label: 'Food & Drink', icon: '🍽️', color: '#f97316' },
  'ETC1_community_networking': { label: 'Community', icon: '🤝', color: '#6366f1' },
  'ETC1_sport_fitness': { label: 'Sports & Fitness', icon: '💪', color: '#3b82f6' },
  'ETC1_arts_culture': { label: 'Arts & Culture', icon: '🎨', color: '#ec4899' },
  'ETC1_business_education': { label: 'Business & Education', icon: '💼', color: '#64748b' },
  'ETC1_markets_pop_ups': { label: 'Markets & Pop-ups', icon: '🛍️', color: '#a855f7' },
  'ETC1_seasonal_holidays': { label: 'Seasonal', icon: '🎄', color: '#ef4444' },
  'ETC1_family_kids': { label: 'Family & Kids', icon: '👨‍👩‍👧', color: '#f472b6' },
  'ETC1_wellness_mindfulness': { label: 'Wellness', icon: '🧘', color: '#10b981' },
  'ETC1_motorsports': { label: 'Motorsports', icon: '🏎️', color: '#dc2626' },
  'ETC1_water_activities': { label: 'Water Activities', icon: '🌊', color: '#0ea5e9' },
  'ENTERTAINMENT': { label: 'Entertainment', icon: '🎭', color: '#ea580c' }
};

// ETC2 (Level 2 - Sub Categories) Display Names
export const ETC2_CONFIG = {
  'ETC2_adventure_parks': { label: 'Adventure Parks', icon: '🧗', parent: 'ETC1_outdoor_adventure' },
  'ETC2_beachclub_sunsets': { label: 'Beach Clubs & Sunset', icon: '🌅', parent: 'ETC1_nightlife_entertainment' },
  'ETC2_brunch': { label: 'Brunch', icon: '🥐', parent: 'ETC1_food_drink' },
  'ETC2_buffets': { label: 'Buffets', icon: '🍽️', parent: 'ETC1_food_drink' },
  'ETC2_climbing': { label: 'Climbing', icon: '🧗', parent: 'ETC1_outdoor_adventure' },
  'ETC2_coffee': { label: 'Coffee', icon: '☕', parent: 'ETC1_food_drink' },
  'ETC2_combat_sports': { label: 'Combat Sports', icon: '🥊', parent: 'ETC1_sport_fitness' },
  'ETC2_comedy': { label: 'Comedy', icon: '🎭', parent: 'ETC1_arts_culture' },
  'ETC2_community': { label: 'Community', icon: '👥', parent: 'ETC1_community_networking' },
  'ETC2_cooking_dining_experiences': { label: 'Dining Experiences', icon: '👨‍🍳', parent: 'ETC1_food_drink' },
  'ETC2_dance': { label: 'Dance', icon: '💃', parent: 'ETC1_nightlife_entertainment' },
  'ETC2_day_parties': { label: 'Day Parties', icon: '🎉', parent: 'ETC1_nightlife_entertainment' },
  'ETC2_dj_club_nights': { label: 'DJ & Club Nights', icon: '🎧', parent: 'ETC1_nightlife_entertainment' },
  'ETC2_endurance': { label: 'Endurance', icon: '🏃', parent: 'ETC1_sport_fitness' },
  'ETC2_equestrian': { label: 'Equestrian', icon: '🐴', parent: 'ETC1_sport_fitness' },
  'ETC2_expos_conferences': { label: 'Expos & Conferences', icon: '📊', parent: 'ETC1_business_education' },
  'ETC2_farmers_markets': { label: 'Farmers Markets', icon: '🥕', parent: 'ETC1_markets_pop_ups' },
  'ETC2_festival': { label: 'Festival', icon: '🎪', parent: 'ETC1_arts_culture' },
  'ETC2_film': { label: 'Film', icon: '🎬', parent: 'ETC1_arts_culture' },
  'ETC2_games_activities': { label: 'Games & Activities', icon: '🎲', parent: 'ETC1_nightlife_entertainment' },
  'ETC2_gym_classes': { label: 'Gym Classes', icon: '🏋️', parent: 'ETC1_sport_fitness' },
  'ETC2_hackathons': { label: 'Hackathons', icon: '💻', parent: 'ETC1_business_education' },
  'ETC2_healing_alternative': { label: 'Healing', icon: '🌿', parent: 'ETC1_wellness_mindfulness' },
  'ETC2_hiking_trekking': { label: 'Hiking', icon: '🥾', parent: 'ETC1_outdoor_adventure' },
  'ETC2_holiday_dining': { label: 'Holiday Dining', icon: '🦃', parent: 'ETC1_food_drink' },
  'ETC2_kids_activities': { label: 'Kids Activities', icon: '👶', parent: 'ETC1_family_kids' },
  'ETC2_language_exchange': { label: 'Language Exchange', icon: '🗣️', parent: 'ETC1_community_networking' },
  'ETC2_literature': { label: 'Literature', icon: '📚', parent: 'ETC1_arts_culture' },
  'ETC2_live_music': { label: 'Live Music', icon: '🎸', parent: 'ETC1_nightlife_entertainment' },
  'ETC2_live_performance': { label: 'Live Performance', icon: '🎤', parent: 'ETC1_arts_culture' },
  'ETC2_markets': { label: 'Markets', icon: '🛒', parent: 'ETC1_markets_pop_ups' },
  'ETC2_meditation_breathwork': { label: 'Meditation & Breathwork', icon: '🕉️', parent: 'ETC1_wellness_mindfulness' },
  'ETC2_mind_body': { label: 'Mind & Body', icon: '✨', parent: 'ETC1_sport_fitness' },
  'ETC2_motorsports': { label: 'Motorsports', icon: '🏁', parent: 'ETC1_motorsports' },
  'ETC2_networking': { label: 'Networking', icon: '🤝', parent: 'ETC1_business_education' },
  'ETC2_night_markets': { label: 'Night Markets', icon: '🏮', parent: 'ETC1_markets_pop_ups' },
  'ETC2_nightlife': { label: 'Nightlife', icon: '🌙', parent: 'ETC1_nightlife_entertainment' },
  'ETC2_outdoor_activities': { label: 'Outdoor Activities', icon: '🏕️', parent: 'ETC1_outdoor_adventure' },
  'ETC2_pop_ups': { label: 'Pop-ups', icon: '🎪', parent: 'ETC1_markets_pop_ups' },
  'ETC2_promos': { label: 'Promos & Deals', icon: '🎁', parent: 'ETC1_food_drink' },
  'ETC2_racket_sports': { label: 'Racket Sports', icon: '🎾', parent: 'ETC1_sport_fitness' },
  'ETC2_recovery_spa': { label: 'Recovery & Spa', icon: '💆', parent: 'ETC1_wellness_mindfulness' },
  'ETC2_seasonal_events': { label: 'Seasonal Events', icon: '🎃', parent: 'ETC1_seasonal_holidays' },
  'ETC2_shows': { label: 'Shows', icon: '🌟', parent: 'ETC1_nightlife_entertainment' },
  'ETC2_spectator_sports': { label: 'Spectator Sports', icon: '🏟️', parent: 'ETC1_sport_fitness' },
  'ETC2_startup_events': { label: 'Startup Events', icon: '🚀', parent: 'ETC1_business_education' },
  'ETC2_strength_power': { label: 'Strength & Power', icon: '💪', parent: 'ETC1_sport_fitness' },
  'ETC2_talks_panels': { label: 'Talks & Panels', icon: '🎙️', parent: 'ETC1_business_education' },
  'ETC2_tastings': { label: 'Tastings', icon: '🍷', parent: 'ETC1_food_drink' },
  'ETC2_team_sports': { label: 'Team Sports', icon: '⚽', parent: 'ETC1_sport_fitness' },
  'ETC2_theatre': { label: 'Theatre', icon: '🎭', parent: 'ETC1_arts_culture' },
  'ETC2_visual_arts_heritage': { label: 'Visual Arts & Heritage', icon: '🖼️', parent: 'ETC1_arts_culture' },
  'ETC2_volunteering': { label: 'Volunteering', icon: '❤️', parent: 'ETC1_community_networking' },
  'ETC2_water_activities': { label: 'Water Activities', icon: '🚣', parent: 'ETC1_outdoor_adventure' },
  'ETC2_water_sports': { label: 'Water Sports', icon: '🏄', parent: 'ETC1_sport_fitness' },
  'ETC2_wellness_sessions': { label: 'Wellness Sessions', icon: '🌸', parent: 'ETC1_wellness_mindfulness' },
  'ETC2_wildlife_nature': { label: 'Wildlife & Nature', icon: '🐘', parent: 'ETC1_outdoor_adventure' },
  'ETC2_workshops': { label: 'Workshops', icon: '🎨', parent: 'ETC1_arts_culture' },
  'ETC2_workshops_classes': { label: 'Workshops & Classes', icon: '🛠️', parent: 'ETC1_business_education' },
  'ETC2_yoga': { label: 'Yoga', icon: '🧘', parent: 'ETC1_wellness_mindfulness' },
  // Legacy fallbacks
  'Live music': { label: 'Live Music', icon: '🎸', parent: 'ETC1_nightlife_entertainment' },
  'fg': { label: 'General', icon: '📅', parent: 'ENTERTAINMENT' },
  'fgngfnf': { label: 'General', icon: '📅', parent: 'ENTERTAINMENT' }
};

// EVENT TYPE SLUGS (Level 3) - All 342 event types with display names and icons
export const EVENT_TYPE_SLUGS = {
  // Adventure Parks
  'et_adventure-park-session': { label: 'Adventure Park Session', icon: '🧗', parent: 'ETC2_adventure_parks' },
  
  // Beach Clubs & Sunset
  'et_sundowner-sunset-session': { label: 'Sundowner / Sunset Session', icon: '🌅', parent: 'ETC2_beachclub_sunsets' },
  
  // Brunch
  'et_beach-club-brunch': { label: 'Beach Club Brunch', icon: '🍹', parent: 'ETC2_brunch' },
  'et_brunch-event': { label: 'Brunch Event', icon: '🥐', parent: 'ETC2_brunch' },
  'et_saturday-brunch': { label: 'Saturday Brunch', icon: '🍳', parent: 'ETC2_brunch' },

  // Buffets
  'et_buffet':             { label: 'Buffet',             icon: '🍽️', parent: 'ETC2_buffets' },
  'et_vegan-buffet':       { label: 'Vegan Buffet',       icon: '🥗', parent: 'ETC2_buffets' },
  'et_vegetarian-buffet':  { label: 'Vegetarian Buffet',  icon: '🥦', parent: 'ETC2_buffets' },
  'et_seafood-buffet':     { label: 'Seafood Buffet',     icon: '🦐', parent: 'ETC2_buffets' },
  'et_breakfast-buffet':   { label: 'Breakfast Buffet',   icon: '🥞', parent: 'ETC2_buffets' },
  'et_brunch-buffet':      { label: 'Brunch Buffet',      icon: '🥐', parent: 'ETC2_buffets' },
  'et_lunch-buffet':       { label: 'Lunch Buffet',       icon: '🍛', parent: 'ETC2_buffets' },
  'et_dinner-buffet':      { label: 'Dinner Buffet',      icon: '🍝', parent: 'ETC2_buffets' },
  'et_hotpot-buffet':      { label: 'Hotpot Buffet',      icon: '🍲', parent: 'ETC2_buffets' },
  'et_bbq-buffet':         { label: 'BBQ Buffet',         icon: '🍖', parent: 'ETC2_buffets' },
  
  // Climbing
  'et_bouldering-session': { label: 'Bouldering Session', icon: '🧗', parent: 'ETC2_climbing' },
  'et_rock-climbing-session': { label: 'Rock Climbing Session', icon: '🧗‍♂️', parent: 'ETC2_climbing' },
  
  // Coffee
  'et_coffee-club-meetup': { label: 'Coffee Club Meetup', icon: '☕', parent: 'ETC2_coffee' },
  'et_roastery-tour': { label: 'Coffee Roastery Tour', icon: '☕', parent: 'ETC2_coffee' },
  
  // Combat Sports (extensive)
  'et_aikido-class': { label: 'Aikido Class', icon: '🥋', parent: 'ETC2_combat_sports' },
  'et_bjj-beginner-class': { label: 'BJJ Beginner Class', icon: '🥋', parent: 'ETC2_combat_sports' },
  'et_bjj-competition-class': { label: 'BJJ Competition Class', icon: '🏆', parent: 'ETC2_combat_sports' },
  'et_bjj-open-mat': { label: 'BJJ Open Mat', icon: '🤼', parent: 'ETC2_combat_sports' },
  'et_bjj-tournament': { label: 'BJJ Tournament', icon: '🏆', parent: 'ETC2_combat_sports' },
  'et_boxing-bag-work-session': { label: 'Boxing Bag Work', icon: '🥊', parent: 'ETC2_combat_sports' },
  'et_boxing-beginner-class': { label: 'Boxing Beginner Class', icon: '🥊', parent: 'ETC2_combat_sports' },
  'et_boxing-class': { label: 'Boxing Class', icon: '🥊', parent: 'ETC2_combat_sports' },
  'et_boxing-fight-camp': { label: 'Boxing Fight Camp', icon: '🥊', parent: 'ETC2_combat_sports' },
  'et_boxing-fitness-class': { label: 'Boxing Fitness Class', icon: '🥊', parent: 'ETC2_combat_sports' },
  'et_boxing-sparring': { label: 'Boxing Sparring', icon: '🥊', parent: 'ETC2_combat_sports' },
  'et_boxing-technique-class': { label: 'Boxing Technique Class', icon: '🥊', parent: 'ETC2_combat_sports' },
  'et_boxing-training': { label: 'Boxing Training', icon: '🥊', parent: 'ETC2_combat_sports' },
  'et_bjj-gi-class': { label: 'BJJ Gi Class', icon: '🥋', parent: 'ETC2_combat_sports' },
  'et_bjj-no-gi-class': { label: 'BJJ No-Gi Class', icon: '🥋', parent: 'ETC2_combat_sports' },
  'et_judo-class': { label: 'Judo Class', icon: '🥋', parent: 'ETC2_combat_sports' },
  'et_karate-class': { label: 'Karate Class', icon: '🥋', parent: 'ETC2_combat_sports' },
  'et_kickboxing-class': { label: 'Kickboxing Class', icon: '🥋', parent: 'ETC2_combat_sports' },
  'et_kickboxing-sparring': { label: 'Kickboxing Sparring', icon: '🥊', parent: 'ETC2_combat_sports' },
  'et_krav-maga-class': { label: 'Krav Maga Class', icon: '🛡️', parent: 'ETC2_combat_sports' },
  'et_mma-class': { label: 'MMA Class', icon: '🥋', parent: 'ETC2_combat_sports' },
  'et_mma-sparring': { label: 'MMA Sparring', icon: '🥊', parent: 'ETC2_combat_sports' },
  'et_muay-thai-beginner-class': { label: 'Muay Thai Beginner', icon: '🥊', parent: 'ETC2_combat_sports' },
  'et_muay-thai-fight-camp': { label: 'Muay Thai Fight Camp', icon: '🥊', parent: 'ETC2_combat_sports' },
  'et_muay-thai-grading': { label: 'Muay Thai Grading', icon: '✅', parent: 'ETC2_combat_sports' },
  'et_muay-thai-pad-session': { label: 'Muay Thai Pad Session', icon: '🥊', parent: 'ETC2_combat_sports' },
  'et_muay-thai-sparring': { label: 'Muay Thai Sparring', icon: '🥊', parent: 'ETC2_combat_sports' },
  'et_muay-thai-technique-class': { label: 'Muay Thai Technique', icon: '🥊', parent: 'ETC2_combat_sports' },
  'et_muay-thai-tournament': { label: 'Muay Thai Tournament', icon: '🏆', parent: 'ETC2_combat_sports' },
  'et_muay-thai-training': { label: 'Muay Thai Training', icon: '🥊', parent: 'ETC2_combat_sports' },
  'et_muay-thai-womens-class': { label: 'Muay Thai Women\'s', icon: '🥊', parent: 'ETC2_combat_sports' },
  'et_self-defense-class': { label: 'Self-Defense Class', icon: '🛡️', parent: 'ETC2_combat_sports' },
  'et_taekwondo-class': { label: 'Taekwondo Class', icon: '🥋', parent: 'ETC2_combat_sports' },
  'et_wing-chun-class': { label: 'Wing Chun Class', icon: '🥋', parent: 'ETC2_combat_sports' },
  'et_wrestling-class': { label: 'Wrestling Class', icon: '🤼', parent: 'ETC2_combat_sports' },
  
  // Comedy
  'et_comedy-night': { label: 'Comedy Night', icon: '🎭', parent: 'ETC2_comedy' },
  'et_standup-comedy-show': { label: 'Stand-up Comedy', icon: '🎤', parent: 'ETC2_comedy' },
  
  // Community
  'et_beach-cleanup': { label: 'Beach Cleanup', icon: '🧹', parent: 'ETC2_community' },
  'et_charity-fundraiser': { label: 'Charity Fundraiser', icon: '❤️', parent: 'ETC2_community' },
  'et_charity-gala': { label: 'Charity Gala', icon: '🎗️', parent: 'ETC2_community' },
  'et_coworking-community-lunch': { label: 'Coworking Lunch', icon: '🍱', parent: 'ETC2_community' },
  'et_fundraiser-run-walk': { label: 'Fundraiser Run/Walk', icon: '🎽', parent: 'ETC2_community' },
  'et_yoga-run-club-social': { label: 'Yoga + Run Social', icon: '🏃‍♀️', parent: 'ETC2_community' },
  'et_digital-nomad-meetup': { label: 'Digital Nomad Meetup', icon: '💻', parent: 'ETC2_community' },
  
  // Cooking & Dining
  'et_bbq-night': { label: 'BBQ Night', icon: '🍖', parent: 'ETC2_cooking_dining_experiences' },
  'et_business-lunch': { label: 'Business Lunch', icon: '💼', parent: 'ETC2_cooking_dining_experiences' },
  'et_coffee-cupping': { label: 'Coffee Cupping', icon: '☕', parent: 'ETC2_cooking_dining_experiences' },
  'et_dinner-show': { label: 'Dinner Show', icon: '🍽️', parent: 'ETC2_cooking_dining_experiences' },
  'et_chef-table': { label: 'Chef\'s Table', icon: '🍽️', parent: 'ETC2_cooking_dining_experiences' },
  'et_cooking-class': { label: 'Cooking Class', icon: '👩‍🍳', parent: 'ETC2_cooking_dining_experiences' },
  'et_live-cooking-demo': { label: 'Live Cooking Demo', icon: '👨‍🍳', parent: 'ETC2_cooking_dining_experiences' },
  'et_thai-cooking-class': { label: 'Thai Cooking Class', icon: '🍲', parent: 'ETC2_cooking_dining_experiences' },
  'et_dinner-club': { label: 'Dinner Club', icon: '🍽️', parent: 'ETC2_cooking_dining_experiences' },
  'et_bread-baking-class': { label: 'Bread Baking Class', icon: '🍞', parent: 'ETC2_cooking_dining_experiences' },
  'et_chefs-tasting-dinner': { label: 'Chef\'s Tasting Dinner', icon: '🍽️', parent: 'ETC2_cooking_dining_experiences' },
  'et_dinner-in-the-sky': { label: 'Dinner in the Sky', icon: '🌆', parent: 'ETC2_cooking_dining_experiences' },
  'et_thai-dinner-cultural-performance': { label: 'Thai Dinner Show', icon: '🍛', parent: 'ETC2_cooking_dining_experiences' },
  
  // Dance
  'et_salsa-bachata-social': { label: 'Salsa / Bachata Social', icon: '💃', parent: 'ETC2_dance' },
  'et_social-dance-night': { label: 'Social Dance Night', icon: '💃', parent: 'ETC2_dance' },
  'et_latin-night': { label: 'Latin Night', icon: '💃', parent: 'ETC2_dance' },
  'et_kizomba-social': { label: 'Kizomba Social', icon: '💃', parent: 'ETC2_dance' },
  'et_aerial-silks-class': { label: 'Aerial Silks Class', icon: '🪂', parent: 'ETC2_dance' },
  'et_barre-class': { label: 'Barre Class', icon: '🩰', parent: 'ETC2_dance' },
  'et_capoeira-class': { label: 'Capoeira Class', icon: '🥋', parent: 'ETC2_dance' },
  'et_dance-fitness-class': { label: 'Dance Fitness Class', icon: '🕺', parent: 'ETC2_dance' },
  'et_les-mills-bodycombat': { label: 'BODYCOMBAT', icon: '🥋', parent: 'ETC2_dance' },
  'et_pole-dance-class': { label: 'Pole Dance Class', icon: '🌀', parent: 'ETC2_dance' },
  'et_zumba-dance-fitness': { label: 'Zumba / Dance Fitness', icon: '🕺', parent: 'ETC2_dance' },
  'et_zumba-class': { label: 'Zumba Class', icon: '💃', parent: 'ETC2_dance' },
  'et_dance-fitness-social': { label: 'Dance Fitness Social', icon: '💃', parent: 'ETC2_dance' },
  'et_aerial-hoop-lyra-class': { label: 'Aerial Hoop / Lyra', icon: '⭕', parent: 'ETC2_dance' },
  'et_pole-fitness-class': { label: 'Pole Fitness Class', icon: '🎭', parent: 'ETC2_dance' },
  
  // Day Parties
  'et_pool-party': { label: 'Pool Party', icon: '🏊', parent: 'ETC2_day_parties' },
  'et_beach-club-day-party': { label: 'Beach Club Day Party', icon: '🏖️', parent: 'ETC2_day_parties' },
  
  // DJ & Club Nights
  'et_live-dj-set': { label: 'Live DJ Set', icon: '🎧', parent: 'ETC2_dj_club_nights' },
  'et_dj-night': { label: 'DJ Night', icon: '🎧', parent: 'ETC2_dj_club_nights' },
  'et_rave-edm-night': { label: 'Rave / EDM Night', icon: '🎧', parent: 'ETC2_dj_club_nights' },
  'et_after-brunch-dj-session': { label: 'After-Brunch DJ', icon: '🎧', parent: 'ETC2_dj_club_nights' },
  
  // Endurance
  'et_running-form-clinic': { label: 'Running Form Clinic', icon: '👟', parent: 'ETC2_endurance' },
  'et_obstacle-course-training': { label: 'OCR Training', icon: '🧗', parent: 'ETC2_endurance' },
  'et_aqua-aerobics': { label: 'Aqua Aerobics', icon: '🏊‍♀️', parent: 'ETC2_endurance' },
  'et_aqua-zumba': { label: 'Aqua Zumba', icon: '💦', parent: 'ETC2_endurance' },
  'et_beach-run': { label: 'Beach Run', icon: '🏖️', parent: 'ETC2_endurance' },
  'et_cycling-group-ride-road': { label: 'Cycling Group Ride', icon: '🚴', parent: 'ETC2_endurance' },
  'et_cycling-race': { label: 'Cycling Race', icon: '🏁', parent: 'ETC2_endurance' },
  'et_easy-run': { label: 'Easy Run', icon: '🏃', parent: 'ETC2_endurance' },
  'et_spinning-endurance-ride': { label: 'Endurance Spin', icon: '🚴‍♀️', parent: 'ETC2_endurance' },
  'et_fitness-throwdown': { label: 'Fitness Throwdown', icon: '🏆', parent: 'ETC2_endurance' },
  'et_group-run': { label: 'Group Run', icon: '🏃', parent: 'ETC2_endurance' },
  'et_hyrox-race': { label: 'HYROX Race', icon: '🏁', parent: 'ETC2_endurance' },
  'et_half-marathon-race': { label: 'Half Marathon', icon: '🏁', parent: 'ETC2_endurance' },
  'et_hill-repeats-session': { label: 'Hill Repeats', icon: '⛰️', parent: 'ETC2_endurance' },
  'et_long-run': { label: 'Long Run', icon: '🏃‍♂️', parent: 'ETC2_endurance' },
  'et_marathon-race': { label: 'Marathon Race', icon: '🏁', parent: 'ETC2_endurance' },
  'et_rowing-class': { label: 'Rowing Class', icon: '🚣', parent: 'ETC2_endurance' },
  'et_running-club': { label: 'Running Club', icon: '🏃', parent: 'ETC2_endurance' },
  'et_spartan-race': { label: 'Spartan / OCR Race', icon: '🏁', parent: 'ETC2_endurance' },
  'et_spin-class': { label: 'Spin Class', icon: '🚴', parent: 'ETC2_endurance' },
  'et_stair-workout': { label: 'Stair Workout', icon: '🪜', parent: 'ETC2_endurance' },
  'et_swim-training-session': { label: 'Swim Training', icon: '🏊', parent: 'ETC2_endurance' },
  'et_swim-lesson': { label: 'Swimming Lesson', icon: '🏊', parent: 'ETC2_endurance' },
  'et_tempo-run-session': { label: 'Tempo Run', icon: '🏃‍♂️', parent: 'ETC2_endurance' },
  'et_track-intervals-session': { label: 'Track Intervals', icon: '🏃‍♀️', parent: 'ETC2_endurance' },
  'et_triathlon-race': { label: 'Triathlon Race', icon: '🏁', parent: 'ETC2_endurance' },
  'et_triathlon-training-meetup': { label: 'Triathlon Training', icon: '🏊‍♂️', parent: 'ETC2_endurance' },
  
  // Equestrian
  'et_equestrian-show-jumping-camp': { label: 'Show Jumping Camp', icon: '🐎', parent: 'ETC2_equestrian' },
  
  // Expos & Conferences
  'et_business-conference': { label: 'Business Conference', icon: '📊', parent: 'ETC2_expos_conferences' },
  'et_boat-show': { label: 'Boat Show', icon: '⛵', parent: 'ETC2_expos_conferences' },
  'et_eco-education-fair': { label: 'Eco Education Fair', icon: '🌿', parent: 'ETC2_expos_conferences' },
  
  // Farmers Markets
  'et_farmers-market': { label: 'Farmers Market', icon: '🥕', parent: 'ETC2_farmers_markets' },
  
  // Festival
  'et_cultural-festival': { label: 'Cultural Festival', icon: '🕌', parent: 'ETC2_festival' },
  'et_food-festival': { label: 'Food Festival', icon: '🍔', parent: 'ETC2_festival' },
  
  // Film
  'et_film-screening': { label: 'Film Screening', icon: '🎬', parent: 'ETC2_film' },
  'et_ladies-movie-night': { label: 'Ladies Movie Night', icon: '🎬', parent: 'ETC2_film' },
  'et_secret-cinema-screening': { label: 'Secret Cinema', icon: '🎬', parent: 'ETC2_film' },
  
  // Games & Activities
  'et_bingo-night': { label: 'Bingo Night', icon: '🎟️', parent: 'ETC2_games_activities' },
  'et_game-night-board-card': { label: 'Game Night', icon: '🎲', parent: 'ETC2_games_activities' },
  'et_bowling-night': { label: 'Bowling Night', icon: '🎳', parent: 'ETC2_games_activities' },
  'et_board-game-night': { label: 'Board Game Night', icon: '🎲', parent: 'ETC2_games_activities' },
  'et_backgammon-club': { label: 'Backgammon Club', icon: '🎲', parent: 'ETC2_games_activities' },
  'et_trivia-night': { label: 'Trivia Night', icon: '🧠', parent: 'ETC2_games_activities' },
  'et_pub-quiz-night': { label: 'Pub Quiz Night', icon: '🧠', parent: 'ETC2_games_activities' },
  
  // Gym Classes (extensive)
  'et_bootcamp': { label: 'Bootcamp', icon: '🎖️', parent: 'ETC2_gym_classes' },
  'et_circuit-training-class': { label: 'Circuit Training', icon: '🔁', parent: 'ETC2_gym_classes' },
  'et_core-abs-class': { label: 'Core / Abs Class', icon: '🧱', parent: 'ETC2_gym_classes' },
  'et_crossfit-fundamentals': { label: 'CrossFit Fundamentals', icon: '🧩', parent: 'ETC2_gym_classes' },
  'et_crossfit-wod': { label: 'CrossFit WOD', icon: '🏋️', parent: 'ETC2_gym_classes' },
  'et_functional-fitness-class': { label: 'Functional Fitness', icon: '🏋️‍♀️', parent: 'ETC2_gym_classes' },
  'et_gymnastics-skills-class': { label: 'Gymnastics Skills', icon: '🤸', parent: 'ETC2_gym_classes' },
  'et_hiit-fitness-class': { label: 'HIIT / Fitness Class', icon: '💪', parent: 'ETC2_gym_classes' },
  'et_hiit-class': { label: 'HIIT Class', icon: '⚡', parent: 'ETC2_gym_classes' },
  'et_hyrox-training': { label: 'HYROX Training', icon: '🏃‍♂️', parent: 'ETC2_gym_classes' },
  'et_les-mills-bodypump': { label: 'BODYPUMP', icon: '🏋️', parent: 'ETC2_gym_classes' },
  'et_les-mills-grit': { label: 'LES MILLS GRIT', icon: '⚡', parent: 'ETC2_gym_classes' },
  'et_metcon-class': { label: 'MetCon Class', icon: '🔥', parent: 'ETC2_gym_classes' },
  'et_partner-wod': { label: 'Partner WOD', icon: '👥', parent: 'ETC2_gym_classes' },
  'et_rope-climb-skills': { label: 'Rope Climb Skills', icon: '🪢', parent: 'ETC2_gym_classes' },
  'et_senior-fitness-class': { label: 'Senior Fitness', icon: '👵', parent: 'ETC2_gym_classes' },
  'et_sled-push-session': { label: 'Sled Push Session', icon: '🛷', parent: 'ETC2_gym_classes' },
  'et_small-group-training': { label: 'Small Group Training', icon: '👥', parent: 'ETC2_gym_classes' },
  'et_trx-suspension-class': { label: 'TRX Class', icon: '🪢', parent: 'ETC2_gym_classes' },
  'et_tabata-class': { label: 'Tabata Class', icon: '⏱️', parent: 'ETC2_gym_classes' },
  'et_bodybuilding-class': { label: 'Bodybuilding Class', icon: '💪', parent: 'ETC2_gym_classes' },
  'et_bodyweight-calisthenics-class': { label: 'Calisthenics Class', icon: '🤸‍♂️', parent: 'ETC2_gym_classes' },
  'et_calisthenics-park-meetup': { label: 'Calisthenics Meetup', icon: '💪', parent: 'ETC2_gym_classes' },
  
  // Kids Activities
  'et_kids-arts-crafts': { label: 'Kids Arts & Crafts', icon: '🎨', parent: 'ETC2_kids_activities' },
  'et_kids-cooking-class': { label: 'Kids Cooking Class', icon: '👨‍🍳', parent: 'ETC2_kids_activities' },
  'et_kids-martial-arts-class': { label: 'Kids Martial Arts', icon: '🥋', parent: 'ETC2_kids_activities' },
  'et_kids-story-time': { label: 'Kids Story Time', icon: '📖', parent: 'ETC2_kids_activities' },
  'et_kids-yoga': { label: 'Kids Yoga', icon: '🧒', parent: 'ETC2_kids_activities' },
  'et_kids-movie-night': { label: 'Kids Movie Night', icon: '🍿', parent: 'ETC2_kids_activities' },
  
  // Language Exchange
  'et_language-exchange': { label: 'Language Exchange', icon: '🗣️', parent: 'ETC2_language_exchange' },
  
  // Literature
  'et_book-club': { label: 'Book Club', icon: '📚', parent: 'ETC2_literature' },
  'et_book-launch': { label: 'Book Launch', icon: '📚', parent: 'ETC2_literature' },
  'et_poetry-reading': { label: 'Poetry Reading', icon: '📜', parent: 'ETC2_literature' },
  'et_poetry-slam': { label: 'Poetry Slam', icon: '🎤', parent: 'ETC2_literature' },
  
  // Live Music
  'et_house-music-night': { label: 'House Music Night', icon: '🎧', parent: 'ETC2_live_music' },
  'et_live-acoustic-set': { label: 'Live Acoustic Set', icon: '🎸', parent: 'ETC2_live_music' },
  'et_live-band': { label: 'Live Band', icon: '🎸', parent: 'ETC2_live_music' },
  'et_live-jazz-night': { label: 'Live Jazz Night', icon: '🎷', parent: 'ETC2_live_music' },
  'et_open-decks-night': { label: 'Open Decks Night', icon: '🎛️', parent: 'ETC2_live_music' },
  'et_movie-night-outdoor': { label: 'Outdoor Movie Night', icon: '🎬', parent: 'ETC2_live_music' },
  'et_jam-session': { label: 'Jam Session', icon: '🎸', parent: 'ETC2_live_music' },
  
  // Live Performance
  'et_pottery-class': { label: 'Pottery Class', icon: '🏺', parent: 'ETC2_live_performance' },
  'et_open-mic': { label: 'Open Mic', icon: '🎙️', parent: 'ETC2_live_performance' },
  
  // Markets
  'et_craft-fair': { label: 'Craft Fair', icon: '🧵', parent: 'ETC2_markets' },
  'et_vintage-market': { label: 'Vintage Market', icon: '🧥', parent: 'ETC2_markets' },
  
  // Meditation & Breathwork
  'et_meditation-session': { label: 'Meditation Session', icon: '🧘‍♂️', parent: 'ETC2_meditation_breathwork' },
  'et_qigong-class': { label: 'Qigong Class', icon: '☯️', parent: 'ETC2_meditation_breathwork' },
  'et_sound-bath': { label: 'Sound Bath', icon: '🔔', parent: 'ETC2_meditation_breathwork' },
  
  // Mind & Body
  'et_breathwork-session': { label: 'Breathwork Session', icon: '🌬️', parent: 'ETC2_mind_body' },
  'et_les-mills-bodybalance': { label: 'BODYBALANCE', icon: '🧘', parent: 'ETC2_mind_body' },
  'et_meditation-class': { label: 'Meditation Class', icon: '🧘‍♂️', parent: 'ETC2_mind_body' },
  'et_pilates-class': { label: 'Pilates Class', icon: '🤸', parent: 'ETC2_mind_body' },
  'et_pilates-mat-class': { label: 'Pilates Mat Class', icon: '🧘', parent: 'ETC2_mind_body' },
  'et_reformer-pilates-class': { label: 'Reformer Pilates', icon: '🧘‍♀️', parent: 'ETC2_mind_body' },
  'et_yoga-session': { label: 'Yoga Session', icon: '🧘', parent: 'ETC2_mind_body' },
  'et_tai-chi-class': { label: 'Tai Chi Class', icon: '☯️', parent: 'ETC2_mind_body' },
  'et_acro-yoga-practice': { label: 'Acro Yoga', icon: '🤸', parent: 'ETC2_mind_body' },
  'et_pranayama-class': { label: 'Pranayama Class', icon: '🌬️', parent: 'ETC2_mind_body' },
  'et_sound-healing-circle': { label: 'Sound Healing Circle', icon: '🎶', parent: 'ETC2_mind_body' },
  
  // Motorsports
  'et_motorbike-day-ride': { label: 'Motorbike Day Ride', icon: '🏍️', parent: 'ETC2_motorsports' },
  
  // Networking
  'et_networking-mixer': { label: 'Networking Mixer', icon: '🤝', parent: 'ETC2_networking' },
  'et_superyacht-rendezvous': { label: 'Superyacht Rendezvous', icon: '🛥️', parent: 'ETC2_networking' },
  
  // Night Markets
  'et_night-market': { label: 'Night Market', icon: '🏮', parent: 'ETC2_night_markets' },
  
  // Nightlife
  'et_rooftop-party': { label: 'Rooftop Party', icon: '🌇', parent: 'ETC2_nightlife' },
  'et_techno-night': { label: 'Techno Night', icon: '🎧', parent: 'ETC2_nightlife' },
  'et_pub-crawl': { label: 'Pub Crawl', icon: '🍻', parent: 'ETC2_nightlife' },
  
  // Outdoor Activities
  'et_sunset-cruise': { label: 'Sunset Cruise', icon: '🛥️', parent: 'ETC2_outdoor_activities' },
  
  // Pop-ups
  'et_pop-up-market': { label: 'Pop-up Market', icon: '🛍️', parent: 'ETC2_pop_ups' },
  
  // Promos & Deals
  'et_gents-night': { label: 'Gents Night', icon: '👔', parent: 'ETC2_promos' },
  'et_happy-hour': { label: 'Happy Hour', icon: '🥂', parent: 'ETC2_promos' },
  'et_industry-night': { label: 'Industry Night', icon: '🛎️', parent: 'ETC2_promos' },
  'et_ladies-night': { label: 'Ladies Night', icon: '💃', parent: 'ETC2_promos' },
  
  // Racket Sports
  'et_badminton-session': { label: 'Badminton Session', icon: '🏸', parent: 'ETC2_racket_sports' },
  'et_badminton-tournament': { label: 'Badminton Tournament', icon: '🏆', parent: 'ETC2_racket_sports' },
  'et_padel-beginner-class': { label: 'Padel Beginner', icon: '🎾', parent: 'ETC2_racket_sports' },
  'et_padel-league-night': { label: 'Padel League Night', icon: '🎾', parent: 'ETC2_racket_sports' },
  'et_padel-open-play': { label: 'Padel Open Play', icon: '🎾', parent: 'ETC2_racket_sports' },
  'et_padel-session': { label: 'Padel Session', icon: '🎾', parent: 'ETC2_racket_sports' },
  'et_padel-clinic': { label: 'Padel Clinic', icon: '🎾', parent: 'ETC2_racket_sports' },
  'et_padel-social-mixer': { label: 'Padel Social Mixer', icon: '🎾', parent: 'ETC2_racket_sports' },
  'et_padel-tournament': { label: 'Padel Tournament', icon: '🏆', parent: 'ETC2_racket_sports' },
  'et_pickleball-session': { label: 'Pickleball Session', icon: '🏓', parent: 'ETC2_racket_sports' },
  'et_pickleball-tournament': { label: 'Pickleball Tournament', icon: '🏆', parent: 'ETC2_racket_sports' },
  'et_squash-session': { label: 'Squash Session', icon: '🎾', parent: 'ETC2_racket_sports' },
  'et_table-tennis-session': { label: 'Table Tennis', icon: '🏓', parent: 'ETC2_racket_sports' },
  'et_tennis-social': { label: 'Tennis Social', icon: '🎾', parent: 'ETC2_racket_sports' },
  'et_tennis-tournament': { label: 'Tennis Tournament', icon: '🏆', parent: 'ETC2_racket_sports' },
  
  // Recovery & Spa
  'et_animal-flow-class': { label: 'Animal Flow Class', icon: '🐒', parent: 'ETC2_recovery_spa' },
  'et_mobility-class': { label: 'Mobility Class', icon: '🤸', parent: 'ETC2_recovery_spa' },
  'et_stretch-recovery-class': { label: 'Stretch & Recovery', icon: '🧊', parent: 'ETC2_recovery_spa' },
  'et_contrast-therapy-session': { label: 'Contrast Therapy', icon: '🧊', parent: 'ETC2_recovery_spa' },
  'et_ice-bath-session': { label: 'Ice Bath Session', icon: '🧊', parent: 'ETC2_recovery_spa' },
  'et_ice-bath-social': { label: 'Ice Bath Social', icon: '🧊', parent: 'ETC2_recovery_spa' },
  'et_sauna-session': { label: 'Sauna Session', icon: '🧖', parent: 'ETC2_recovery_spa' },
  'et_massage-therapy-session': { label: 'Sports Massage', icon: '💆', parent: 'ETC2_recovery_spa' },
  'et_wellness-retreat-day': { label: 'Wellness Retreat Day', icon: '🌿', parent: 'ETC2_recovery_spa' },
  'et_sports-physio-clinic': { label: 'Sports Physio Clinic', icon: '🩺', parent: 'ETC2_recovery_spa' },
  
  // Seasonal Events
  'et_new-years-eve-party': { label: 'New Year\'s Eve Party', icon: '🎆', parent: 'ETC2_seasonal_events' },
  'et_temple-festival': { label: 'Temple Festival', icon: '🛕', parent: 'ETC2_seasonal_events' },
  
  // Shows
  'et_theme-park-show-program': { label: 'Theme Park Show', icon: '🎡', parent: 'ETC2_shows' },
  'et_cabaret-show': { label: 'Cabaret Show', icon: '🎭', parent: 'ETC2_shows' },
  'et_fire-show-party': { label: 'Fire Show Party', icon: '🔥', parent: 'ETC2_shows' },
  
  // Spectator Sports
  'et_basketball-game-live': { label: 'Basketball Game', icon: '🏀', parent: 'ETC2_spectator_sports' },
  'et_boxing-match-night': { label: 'Boxing Match Night', icon: '🥊', parent: 'ETC2_spectator_sports' },
  'et_combat-sports-weigh-in': { label: 'Combat Weigh-In', icon: '⚖️', parent: 'ETC2_spectator_sports' },
  'et_cricket-match-viewing': { label: 'Cricket Match Viewing', icon: '🏏', parent: 'ETC2_spectator_sports' },
  'et_e-sports-viewing': { label: 'E-sports Viewing', icon: '🎮', parent: 'ETC2_spectator_sports' },
  'et_football-match-viewing': { label: 'Football Match Viewing', icon: '⚽', parent: 'ETC2_spectator_sports' },
  'et_formula-1-viewing': { label: 'Formula 1 Viewing', icon: '🏎️', parent: 'ETC2_spectator_sports' },
  'et_live-sports-screening': { label: 'Live Sports Screening', icon: '🏟️', parent: 'ETC2_spectator_sports' },
  'et_mma-fight-night': { label: 'MMA Fight Night', icon: '🥊', parent: 'ETC2_spectator_sports' },
  'et_muay-thai-fight-night': { label: 'Muay Thai Fight Night', icon: '🥊', parent: 'ETC2_spectator_sports' },
  'et_regatta-viewing': { label: 'Regatta Viewing', icon: '⛵', parent: 'ETC2_spectator_sports' },
  'et_ufc-mma-viewing': { label: 'UFC / MMA Viewing', icon: '🥊', parent: 'ETC2_spectator_sports' },
  
  // Startup Events
  'et_founder-meetup': { label: 'Founder Meetup', icon: '🚀', parent: 'ETC2_startup_events' },
  'et_startup-demo-day': { label: 'Startup Demo Day', icon: '🎤', parent: 'ETC2_startup_events' },
  'et_startup-pitch-night': { label: 'Startup Pitch Night', icon: '🚀', parent: 'ETC2_startup_events' },
  'et_tech-meetup': { label: 'Tech Meetup', icon: '💻', parent: 'ETC2_startup_events' },
  
  // Strength & Power
  'et_aerial-strap-training': { label: 'Aerial Strap Training', icon: '🪢', parent: 'ETC2_strength_power' },
  
  // Talks & Panels
  'et_martial-arts-seminar': { label: 'Martial Arts Seminar', icon: '🎓', parent: 'ETC2_talks_panels' },
  
  // Tastings
  'et_beer-tasting': { label: 'Beer Tasting', icon: '🍺', parent: 'ETC2_tastings' },
  'et_cocktail-masterclass': { label: 'Cocktail Masterclass', icon: '🍸', parent: 'ETC2_tastings' },
  'et_craft-beer-festival': { label: 'Craft Beer Festival', icon: '🍺', parent: 'ETC2_tastings' },
  'et_wine-pairing-dinner': { label: 'Wine Pairing Dinner', icon: '🍷', parent: 'ETC2_tastings' },
  'et_wine-tasting': { label: 'Wine Tasting', icon: '🍷', parent: 'ETC2_tastings' },
  'et_cheese-tasting': { label: 'Cheese Tasting', icon: '🧀', parent: 'ETC2_tastings' },
  'et_chocolate-tasting': { label: 'Chocolate Tasting', icon: '🍫', parent: 'ETC2_tastings' },
  
  // Team Sports
  'et_beach-volleyball-game': { label: 'Beach Volleyball', icon: '🏐', parent: 'ETC2_team_sports' },
  'et_skate-session': { label: 'Skate Session', icon: '🛹', parent: 'ETC2_team_sports' },
  'et_basketball-pickup': { label: 'Basketball Pickup', icon: '🏀', parent: 'ETC2_team_sports' },
  'et_beach-volleyball-tournament': { label: 'Beach Volleyball Tournament', icon: '🏆', parent: 'ETC2_team_sports' },
  'et_beach-volleyball-training': { label: 'Beach Volleyball Training', icon: '🏐', parent: 'ETC2_team_sports' },
  'et_football-futsal-pickup': { label: 'Football / Futsal Pickup', icon: '⚽', parent: 'ETC2_team_sports' },
  'et_touch-rugby-session': { label: 'Touch Rugby', icon: '🏉', parent: 'ETC2_team_sports' },
  'et_ultimate-frisbee-session': { label: 'Ultimate Frisbee', icon: '🥏', parent: 'ETC2_team_sports' },
  'et_water-polo-social': { label: 'Water Polo Social', icon: '🤽', parent: 'ETC2_team_sports' },
  'et_ball-hockey-session': { label: 'Ball Hockey', icon: '🏑', parent: 'ETC2_team_sports' },
  'et_field-hockey-session': { label: 'Field Hockey', icon: '🏑', parent: 'ETC2_team_sports' },
  'et_cricket-practice-session': { label: 'Cricket Practice', icon: '🏏', parent: 'ETC2_team_sports' },
  'et_cricket-match': { label: 'Cricket Match', icon: '🏏', parent: 'ETC2_team_sports' },
  
  // Theatre
  'et_live-theatre': { label: 'Live Theatre', icon: '🎭', parent: 'ETC2_theatre' },
  'et_cultural-theatre-show': { label: 'Cultural Theatre Show', icon: '🎭', parent: 'ETC2_theatre' },
  
  // Visual Arts & Heritage
  'et_art-exhibition': { label: 'Art Exhibition', icon: '🖼️', parent: 'ETC2_visual_arts_heritage' },
  'et_art-talk': { label: 'Art Talk', icon: '🗣️', parent: 'ETC2_visual_arts_heritage' },
  'et_art-workshop': { label: 'Art Workshop', icon: '🎨', parent: 'ETC2_visual_arts_heritage' },
  'et_gallery-opening': { label: 'Gallery Opening', icon: '🖼️', parent: 'ETC2_visual_arts_heritage' },
  'et_museum-night': { label: 'Museum Night', icon: '🏛️', parent: 'ETC2_visual_arts_heritage' },
  'et_art-biennale': { label: 'Art Biennale', icon: '🖼️', parent: 'ETC2_visual_arts_heritage' },
  
  // Volunteering
  'et_community-volunteering-day': { label: 'Community Volunteering', icon: '🤝', parent: 'ETC2_volunteering' },
  
  // Water Activities
  'et_freediving-training': { label: 'Freediving Training', icon: '🫧', parent: 'ETC2_water_activities' },
  'et_open-water-swim': { label: 'Open Water Swim', icon: '🌊', parent: 'ETC2_water_activities' },
  'et_kayaking-session': { label: 'Kayaking Session', icon: '🛶', parent: 'ETC2_water_activities' },
  'et_kitesurf-lesson': { label: 'Kitesurf Lesson', icon: '🪁', parent: 'ETC2_water_activities' },
  'et_sailing-session': { label: 'Sailing Session', icon: '⛵', parent: 'ETC2_water_activities' },
  'et_scuba-dive-trip': { label: 'Scuba Dive Trip', icon: '🤿', parent: 'ETC2_water_activities' },
  'et_snorkeling-trip': { label: 'Snorkeling Trip', icon: '🤿', parent: 'ETC2_water_activities' },
  'et_sup-session': { label: 'SUP Session', icon: '🏄‍♀️', parent: 'ETC2_water_activities' },
  'et_surf-lesson': { label: 'Surf Lesson', icon: '🏄‍♂️', parent: 'ETC2_water_activities' },
  'et_surf-session': { label: 'Surf Session', icon: '🏄', parent: 'ETC2_water_activities' },
  'et_wakeboarding-session': { label: 'Wakeboarding', icon: '🏄', parent: 'ETC2_water_activities' },
  
  // Water Sports
  'et_regatta': { label: 'Sailing Regatta', icon: '🏁', parent: 'ETC2_water_sports' },
  
  // Wellness Sessions
  'et_handstand-class': { label: 'Handstand Class', icon: '🤸‍♂️', parent: 'ETC2_wellness_sessions' },
  'et_mobility-flow-class': { label: 'Mobility Flow', icon: '🧘', parent: 'ETC2_wellness_sessions' },
  
  // Wildlife & Nature
  'et_elephant-sanctuary-experience': { label: 'Elephant Sanctuary', icon: '🐘', parent: 'ETC2_wildlife_nature' },
  
  // Workshops
  'et_paint-and-sip': { label: 'Paint & Sip', icon: '🎨', parent: 'ETC2_workshops' },
  
  // Workshops & Classes
  'et_cycling-maintenance-workshop': { label: 'Bike Maintenance', icon: '🔧', parent: 'ETC2_workshops_classes' },
  'et_dance-workshop': { label: 'Dance Workshop', icon: '🎓', parent: 'ETC2_workshops_classes' },
  'et_freediving-course': { label: 'Freediving Course', icon: '🎓', parent: 'ETC2_workshops_classes' },
  'et_masterclass-cooking': { label: 'Cooking Masterclass', icon: '👨‍🍳', parent: 'ETC2_workshops_classes' },
  'et_mindfulness-workshop': { label: 'Mindfulness Workshop', icon: '🧠', parent: 'ETC2_workshops_classes' },
  'et_mixology-class': { label: 'Mixology Class', icon: '🍸', parent: 'ETC2_workshops_classes' },
  'et_nutrition-workshop': { label: 'Nutrition Workshop', icon: '🥗', parent: 'ETC2_workshops_classes' },
  'et_workshop-photography': { label: 'Photography Workshop', icon: '📷', parent: 'ETC2_workshops_classes' },
  'et_scuba-course': { label: 'Scuba Course', icon: '🎓', parent: 'ETC2_workshops_classes' },
  'et_thai-massage-workshop': { label: 'Thai Massage Workshop', icon: '💆‍♂️', parent: 'ETC2_workshops_classes' },
  'et_workshop': { label: 'Workshop', icon: '🧪', parent: 'ETC2_workshops_classes' },
  
  // Yoga (extensive)
  'et_aerial-yoga': { label: 'Aerial Yoga', icon: '🪂', parent: 'ETC2_yoga' },
  'et_ashtanga-yoga': { label: 'Ashtanga Yoga', icon: '🧘', parent: 'ETC2_yoga' },
  'et_beach-yoga-retreat': { label: 'Beach Yoga Retreat', icon: '🏝️', parent: 'ETC2_yoga' },
  'et_hatha-yoga': { label: 'Hatha Yoga', icon: '🧘‍♂️', parent: 'ETC2_yoga' },
  'et_hot-yoga': { label: 'Hot Yoga', icon: '🌡️', parent: 'ETC2_yoga' },
  'et_power-yoga': { label: 'Power Yoga', icon: '🔥', parent: 'ETC2_yoga' },
  'et_prenatal-yoga': { label: 'Prenatal Yoga', icon: '🤰', parent: 'ETC2_yoga' },
  'et_restorative-yoga': { label: 'Restorative Yoga', icon: '🛌', parent: 'ETC2_yoga' },
  'et_sup-yoga-session': { label: 'SUP Yoga', icon: '🧘‍♀️', parent: 'ETC2_yoga' },
  'et_sunrise-yoga': { label: 'Sunrise Yoga', icon: '🌅', parent: 'ETC2_yoga' },
  'et_sunset-yoga': { label: 'Sunset Yoga', icon: '🌇', parent: 'ETC2_yoga' },
  'et_vinyasa-yoga': { label: 'Vinyasa Yoga', icon: '🧘‍♀️', parent: 'ETC2_yoga' },
  'et_yin-yoga': { label: 'Yin Yoga', icon: '🧘‍♀️', parent: 'ETC2_yoga' },
  'et_yoga-class': { label: 'Yoga Class', icon: '🧘', parent: 'ETC2_yoga' },
  'et_yoga-nidra': { label: 'Yoga Nidra', icon: '😴', parent: 'ETC2_yoga' },
  'et_aerial-hammock-class': { label: 'Aerial Hammock', icon: '🧘', parent: 'ETC2_yoga' }
};

// ── i18n label overrides (v68.406) ──────────────────────────────────────────
// Keyed by slug (ETC1_/ETC2_/et_ ...). Populated from i18n.translations via the
// useEventTypeLabels() hook on locale change. getEtcLabel() and all getters below
// apply the override, so existing call sites localize with no per-site change to
// the getter pattern. Iteration sites that read the raw config use getEtcLabel().
let _etcLabelOverrides = {};
export const setEtcLabelOverrides = (m) => { _etcLabelOverrides = m && typeof m === 'object' ? m : {}; };
export const getEtcLabel = (slug, fallback) => (slug && _etcLabelOverrides[slug]) || txLabel(slug, fallback);

// Helper functions
export const getETC1Config = (etc1) => {
  const base = ETC1_CONFIG[etc1] || { label: etc1 || 'Other', icon: '📅', color: '#6b7280' };
  return { ...base, label: _etcLabelOverrides[etc1] || txLabel(etc1, base.label) };
};
export const getETC2Config = (etc2) => {
  const base = ETC2_CONFIG[etc2] || { label: etc2 || 'Other', icon: '📅', parent: null };
  return { ...base, label: _etcLabelOverrides[etc2] || txLabel(etc2, base.label) };
};
export const getEventTypeConfig = (slug) => {
  const base = EVENT_TYPE_SLUGS[slug] || { label: slug || 'Event', icon: '📅', parent: null };
  return { ...base, label: _etcLabelOverrides[slug] || txLabel(slug, base.label) };
};

// Get display name for any slug (auto-format if not found)
export const getEventTypeDisplayName = (slug) => {
  if (!slug) return 'Event';
  if (_etcLabelOverrides[slug]) return _etcLabelOverrides[slug];
  const config = EVENT_TYPE_SLUGS[slug];
  if (config) return txLabel(slug, config.label);   // CON-1613 — was returning raw English
  // Auto-format: et_happy-hour -> Happy Hour
  return slug.replace('et_', '').split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
};
